import { Component, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent implements OnInit {
  /**
   * Управляет отображением окна "Написать в поддержку".
   */
  public isSupportModalWindowVisible: boolean = false;

  constructor() {}

  ngOnInit() {}

  public getFullYear() {
    return moment().year();
  }
  public supportModalWindowOpen() {
    this.isSupportModalWindowVisible = true;
  }
  public supportModalWindowClose() {
    this.isSupportModalWindowVisible = false;
  }
}
